query PurchaseOrderInvoiceSchedule($id: UUID!) {
  purchaseOrderInvoiceSchedule(id: $id) {
    __typename
    id
    _rowTimestamp
    _isUpdatable
    _isDeletable
    invoiceSequence
    scheduledDate
    scheduledNote
    scheduledAmount
    purchaseOrderInvoiceScheduleDistributions(orderBy: ACCOUNT_REFERENCE_ASC) {
      nodes {
        __typename
        id
        _rowTimestamp
        _createdDate
        _isDeletable
        _isUpdatable
        accountReference
       _accountName
        referenceCode6
        referenceCode7
        scheduledAmount
        productionIncentiveId
        projectReference
        setReference
        tax1099T4TypeId
        referenceCode1
        referenceCode2
        referenceCode3
        referenceCode4
        referenceCode5
      }
    }
  }
}
